import React from 'react';
import { Navigate } from 'react-router-dom';
import { getLS } from '../utils/storage';

export const PrivateRoute = ({ element }) => {
  return element;
  return !getLS('iUserData') || !getLS('token') ? <Navigate to="/login" replace /> : element;
};
